import React from 'react';
//import '../features/ordinediretto.scss';

const CountrySelector = ({ 
    selectedCountry, 
    countries, 
    onChange,
    error 
}) => {
    return (
        <div className="form-group country-selector">
            <label htmlFor="country-select">Paese *</label>
            <select
                id="country-select"
                value={selectedCountry}
                onChange={(e) => onChange(e.target.value)}
                className={error ? 'error' : ''}
            >
                {countries.map(country => (
                    <option key={country.code} value={country.code}>
                        {country.flag} - {country.name}
                    </option>
                ))}
            </select>
            {error && <span className="error-message">{error}</span>}
        </div>
    );
};

export default CountrySelector;
